//  index.js
//  Project hpi
//
//  Created by Axis Maps on 5/4/2020, 1:16:22 PM
//

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./upload-panel.component'),
  loading: () => null,
});
